module.exports = " <popup point=$ctrl.point> <ng-transclude></ng-transclude> </popup> ";